import { doc, runTransaction } from "firebase/firestore";
import { db } from "../../firebase/config";

/** Global COP matrix fill sequence (COP-1, COP-2, … placement). */
export async function allocateCashOutMatrixFillSeq() {
  const counterRef = doc(db, "cashOutMeta", "counters");
  return runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);
    const current = snap.exists()
      ? Number(snap.data().copMatrixFillSeq) || 0
      : 0;
    const fillSeq = current + 1;
    tx.set(counterRef, { copMatrixFillSeq: fillSeq }, { merge: true });
    return fillSeq;
  });
}
